export default {
	state: () => ({
		data: {
			messages: [],
			lastMessageLink:'',
			showsMessageIds:[]
		}
	}),
	mutations: {
		['chat/setStateMessages'](state, payload) {
			state.data.messages = payload;
			if(payload[0]) state.data.lastMessageLink = payload[0].chatLink;
		},

	},
	actions: {
		async ['chat/update']({ state, commit, getters },payload) {
			try {
				const { status, data: responseData } = await axios.post(payload.link, payload.data);
				if (status === 200) {
					commit('chat/setStateMessages', responseData.items);
					let showsMess = localStorage.showsMessage;
					if(showsMess==undefined) {
						showsMess = '[]';
					} else {
						showsMess = '['+showsMess+']';
					}
					showsMess = JSON.parse(showsMess);
					for(let index in responseData.items) {
						if(!showsMess.includes(parseInt(responseData.items[index].id))&&parseInt(responseData.items[index].id)) {
							showNotification('chat',responseData.items[index].title,responseData.items[index].text);
							showsMess.push(responseData.items[index].id);
						}
					}
					localStorage.showsMessage = showsMess;
				}

			} catch (err) {
				console.error(err);
			}
		},
	}
}